import React, { useState, useEffect } from 'react'
import cls from 'classnames'
import { useLocation, useNavigate } from 'react-router-dom'
import { isDesktop } from 'react-device-detect'
import { useSelector } from 'react-redux'

import styles from './index.module.scss'

import financeIcon from '../../assets/account/finance.svg'
import financeActiveIcon from '../../assets/account/finance_active.svg'
import userIcon from '../../assets/account/me.svg'
import userActiveIcon from '../../assets/account/me_active.svg'

export default function Navigation() {
  const location = useLocation()
  const navigate = useNavigate()
  const [activeKey, setActiveKey] = useState('')
  const permissionsBtns = useSelector((state: any) => state.user.permissions.btns) || {}

  useEffect(() => {
    const match = /^\/\w+/.exec(location.pathname)

    if (match) {
      const name = match[0].slice(1)

      switch (name) {
        case 'account':
          setActiveKey('account')
          break
        case 'user':
          setActiveKey('user')
          break
        default:
          setActiveKey('user')
      }
    }
  }, [location])

  const tabs = [
    {
      key: 'account',
      title: '财富',
      icon: (active: boolean) => (active ? financeActiveIcon : financeIcon),
      defaultUrl: 'account',
    },
    {
      key: 'user',
      title: '我的',
      icon: (active: boolean) => (active ? userActiveIcon : userIcon),
      defaultUrl: 'user',
    },
  ].filter((item: any) => {
    return Object.keys(permissionsBtns).includes(item.key)
  })

  return (
    <div className={cls(styles.navigation, { isDesktop })}>
      <div className={styles.inner}>
        {tabs.map(item => {
          const active = item.key === activeKey
          return (
            <div
              key={item.key}
              className={cls(styles.item, { [styles.active]: active })}
              onClick={() => {
                navigate(`/${item.defaultUrl}`)
              }}
            >
              <img className={styles.icon} src={item.icon(active)} alt={item.key} />
              <span className={styles.tip}>{item.title}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
